import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndoor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 2457 2201",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1902.24 963.076C1902.24 1356.39 1546.31 1675.24 1107.24 1675.24C668.178 1675.24 312.246 1356.39 312.246 963.076C312.246 569.76 668.178 250.914 1107.24 250.914C1546.31 250.914 1902.24 569.76 1902.24 963.076Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1409.07 1119.09H1287.87H1277.44C1277.44 1108.44 1287.08 1099.8 1298.98 1099.8H1409.07V1119.09Z",
			fill: "#6C9BAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1456.5 1090.95L1394.58 1085.15L1331.23 1080.5C1331.23 1080.5 1261.13 1095.7 1269.42 1105.02C1272.81 1108.83 1341.28 1105.02 1341.28 1105.02L1401.17 1119.09L1461.77 1118.76L1456.5 1090.95Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1874.79 706.605C1846.5 751.238 1850.98 799.541 1821.61 799.541C1792.24 799.541 1768.43 757.932 1768.43 706.605C1768.43 655.278 1792.24 613.669 1821.61 613.669C1850.98 613.669 1907.63 654.8 1874.79 706.605Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1103.91 1808.84H569.792V1423.16H1103.91V1808.84Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M955.298 1808.84H421.18V1423.16H955.298V1808.84Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2079.84 1384.71H1765.52V877.015L2199.49 877.857L2079.84 1384.71Z",
			fill: "#FFD500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2088.66 1810.69C2088.66 1823.42 1912.64 1833.74 1695.51 1833.74C1478.38 1833.74 1302.36 1823.42 1302.36 1810.69C1302.36 1797.96 1478.38 1787.65 1695.51 1787.65C1912.64 1787.65 2088.66 1797.96 2088.66 1810.69Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1863.76 1762.45H1827.77V1399.51H1863.76V1762.45Z",
			fill: "#FFD500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2022.01 1808.05H1986.02C1986.02 1791.8 1971.25 1778.57 1953.1 1778.57H1741.62C1723.47 1778.57 1708.7 1791.8 1708.7 1808.05H1672.71C1672.71 1774.02 1703.62 1746.33 1741.62 1746.33H1953.1C1991.1 1746.33 2022.01 1774.02 2022.01 1808.05Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M619.324 738.05C599.652 725.557 585.021 707.844 575.025 688.185C552.553 643.987 516.141 616.505 481.796 622.395C436.029 630.245 411.273 694.38 426.503 765.644C441.735 836.908 562.288 967.218 579.899 965.147C595.457 963.317 661.219 827.397 653.141 789.61C648.281 766.868 635.312 748.204 619.324 738.05Z",
			fill: "#3AAA35"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M528.271 706.847C534.582 719.598 540.149 732.645 545.141 745.865C547.717 752.455 549.91 759.153 552.227 765.82C554.291 772.55 556.538 779.242 558.355 786.033C562.306 799.549 565.421 813.243 568.403 826.959C571.129 840.714 573.629 854.516 575.513 868.391C579.405 896.131 581.648 924.046 582.565 952.007C583.13 966.011 583.05 979.934 583.226 993.887L583.605 1035.73L575.833 1035.72L576.425 993.888C576.574 979.951 576.976 965.979 576.737 952.099C576.472 924.292 574.886 896.47 571.653 868.792C570.098 854.944 567.929 841.162 565.532 827.408C562.879 813.697 560.092 799.989 556.467 786.446C554.813 779.639 552.728 772.93 550.824 766.176C548.669 759.486 546.635 752.759 544.217 746.136C539.542 732.848 534.285 719.713 528.271 706.847Z",
			fill: "#8CC3A1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M715.152 831.442C723.421 772.769 709.815 722.907 684.762 720.074C662.495 717.556 638.691 753.042 627.865 802.161C625.967 810.776 620.823 818.71 612.936 823.926C597.487 834.141 589.407 857.719 594.261 883.368C600.323 915.412 639.876 947.712 639.876 947.712C639.876 947.712 706.98 889.435 715.152 831.442Z",
			fill: "#A2C61A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M675.618 752.902C670.322 774.346 665.488 795.876 661.188 817.485C656.916 839.097 653.074 860.776 650.037 882.535C646.986 904.29 644.615 926.116 643.335 947.966C642.126 969.807 641.975 991.712 644.121 1013.36L636.371 1013.9C634.835 991.73 635.653 969.61 637.518 947.633C639.456 925.655 642.484 903.797 646.188 882.053C649.878 860.305 654.366 838.686 659.28 817.156C664.22 795.632 669.692 774.213 675.618 752.902Z",
			fill: "#7AAF94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M644.164 1116.9H537.299C526.718 1116.9 517.674 1110.07 515.879 1100.73L488.291 957.163H693.173L665.585 1100.73C663.789 1110.07 654.745 1116.9 644.164 1116.9Z",
			fill: "#10275B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M700.645 982.354H480.818C478.862 982.354 477.277 980.935 477.277 979.183V934.532C477.277 932.78 478.863 931.359 480.818 931.359H700.645C702.601 931.359 704.186 932.78 704.186 934.532V979.183C704.186 980.935 702.601 982.354 700.645 982.354Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1635.67 799.541L1669.27 809.305L1616.33 983.463C1610.54 1003.06 1557.78 1090.95 1557.78 1090.95C1557.78 1090.95 1538.66 1085.7 1521.03 1061.91C1482.07 1009.32 1635.67 799.541 1635.67 799.541Z",
			fill: "#0072BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1548.24 974.884C1568.41 959.034 1639.02 903.699 1696.94 860.071C1765.27 808.603 1843.93 803.491 1827.96 880.637C1827.96 880.637 1816.8 964.533 1658.04 1038.53C1622.81 1054.95 1582.29 1078.84 1557.78 1090.95C1557.78 1090.95 1548.43 998.287 1548.24 974.884Z",
			fill: "#0072BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1609.93 1060.28C1617.99 1037.23 1648.95 974.213 1659.82 952.104C1668.64 934.17 1684.1 916.173 1702.18 900.299V1015.62C1688.89 1023.29 1674.27 1030.96 1658.04 1038.53C1641.9 1046.05 1625.19 1054.02 1609.43 1061.64C1609.59 1061.18 1609.77 1060.74 1609.93 1060.28Z",
			fill: "#0072BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1835.6 1762.7L1843.72 1787.61C1845.33 1792.53 1844.96 1797.78 1842.66 1802.47C1835.39 1817.31 1813.91 1848.4 1806.28 1844.62C1795.55 1839.31 1814.49 1795.07 1814.49 1795.07L1811.38 1780.17L1835.6 1762.7Z",
			fill: "#50374B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1742.45 1220.23L1839.29 1774.02C1831.68 1780.66 1824.65 1779.81 1811.38 1780.17L1567.24 1259.56L1742.45 1220.23Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1788.76 819.248C1837.52 812.928 1906.06 799.689 1955.87 851.398C1988.62 885.405 1982.43 958.582 1995.12 1034.25C2018.09 1171.24 1981.32 1220.23 1981.32 1220.23C1981.32 1220.23 1798.12 1236 1752.5 1195.13C1747.02 1168.71 1621.38 1059.08 1671.27 935.97C1695.97 875.017 1742.34 825.267 1788.76 819.248Z",
			fill: "#0072BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1774.52 770.858H1824.45C1826.32 784.377 1829.36 799.92 1834.19 817.359C1836.38 825.305 1834.32 833.744 1828.59 840.118C1812.09 858.47 1777.17 889.609 1759.19 848.745C1756.53 842.703 1756.57 835.951 1759.08 829.86C1763.75 818.557 1771.51 796.696 1774.52 770.858Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1840.34 725.508C1840.34 725.508 1842.4 759.354 1820.35 785.489C1812.09 795.266 1798.48 812.03 1772.29 811.318C1756.03 810.877 1743.46 798.645 1734.63 786.199C1705.94 745.765 1708.44 666.758 1708.44 666.758C1708.44 666.758 1800.85 632.693 1832.25 679.556C1838.9 689.482 1840.34 707.764 1840.34 725.508Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1784.32 770.858C1784.32 778.721 1777.21 785.096 1768.43 785.096C1759.65 785.096 1752.53 778.721 1752.53 770.858H1784.32Z",
			fill: "#F9F8F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1789.35 730.531C1789.35 734.518 1791.2 737.752 1793.48 737.752C1795.77 737.752 1797.62 734.518 1797.62 730.531C1797.62 726.543 1795.77 723.31 1793.48 723.31C1791.2 723.31 1789.35 726.543 1789.35 730.531Z",
			fill: "#523528"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1734.49 730.531C1734.49 734.518 1736.35 737.752 1738.63 737.752C1740.92 737.752 1742.77 734.518 1742.77 730.531C1742.77 726.543 1740.92 723.31 1738.63 723.31C1736.35 723.31 1734.49 726.543 1734.49 730.531Z",
			fill: "#523528"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1766.21 725.083L1759.23 750.518C1758.8 753.44 1759.8 758.362 1767.52 758.362C1770.99 758.362 1773.58 755.49 1772.84 752.449L1766.21 725.083Z",
			fill: "#FF640A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1783.89 711.888C1786.32 710.428 1788.82 709.742 1791.33 709.306C1793.84 708.905 1796.36 708.821 1798.87 709.064C1801.38 709.309 1803.87 709.837 1806.27 710.8C1808.64 711.778 1811.01 713.099 1812.68 715.267C1809.84 715.807 1807.47 716.064 1805.08 716.169C1802.71 716.252 1800.37 716.223 1798.05 715.985C1795.72 715.752 1793.39 715.369 1791.04 714.755C1788.68 714.118 1786.33 713.31 1783.89 711.888Z",
			fill: "#C96E35"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1751.47 713.558C1749.24 714.717 1747.25 715.328 1745.29 715.794C1743.35 716.235 1741.47 716.491 1739.6 716.595C1737.74 716.719 1735.9 716.697 1733.97 716.527C1732.04 716.372 1730.09 716.119 1727.57 715.546C1728.74 713.477 1730.67 712.126 1732.68 711.175C1734.72 710.28 1736.91 709.78 1739.09 709.649C1741.27 709.535 1743.44 709.756 1745.54 710.342C1747.63 710.96 1749.69 711.863 1751.47 713.558Z",
			fill: "#C96E35"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1832.86 661.565C1832.86 661.565 1779.41 706.045 1721.64 703.952C1663.86 701.859 1645.57 658.741 1649.5 637.811C1653.42 616.88 1663.46 549.067 1760.78 603.485C1760.78 603.485 1899.22 591.552 1832.86 661.565Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1830.85 728.85C1826.82 742.633 1829.62 755.233 1837.11 756.991C1844.59 758.75 1853.94 749.002 1857.97 735.219C1862 721.436 1859.2 708.837 1851.71 707.078C1844.22 705.319 1834.88 715.068 1830.85 728.85Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1421.96 1632.81L1410.99 1656.83C1408.82 1661.58 1404.89 1665.47 1399.83 1667.86C1383.82 1675.42 1348.54 1690.15 1341.98 1676.77C1334.95 1662.44 1382.94 1646.35 1382.94 1646.35L1398.8 1627.76L1421.96 1632.81Z",
			fill: "#50374B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2010.76 1323.44C2030.4 1269.52 1988.18 1213.15 1925.74 1203.74C1826.87 1188.85 1657.02 1169.65 1592.51 1201.26C1553.79 1220.23 1382.94 1646.35 1382.94 1646.35C1383.97 1661.93 1418.29 1640.84 1418.29 1640.84L1639.65 1329.78C1639.65 1329.78 1905.94 1415.92 1973.51 1369.97C1993.13 1356.64 2004.6 1340.36 2010.76 1323.44Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1644.43 1187.26C1719.14 1176.27 1844.38 1141.21 1926.59 1149.65C2020.95 1159.33 2051.58 1308.33 1980.54 1364.81C1978.31 1366.58 1975.97 1368.31 1973.51 1369.97C1911.19 1412.34 1713.27 1360.81 1677.68 1349.68L1644.43 1187.26Z",
			fill: "#0072BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1901.73 857.02C1923.44 862.072 1948.34 879.795 1948.23 915.237C1948.13 944.494 1817.54 1105.03 1721.72 1135.7C1638 1162.51 1452.05 1131.29 1440.69 1119.1C1430.6 1108.25 1444.42 1069.71 1444.42 1069.71C1483.55 1076.24 1679.31 1048.38 1679.31 1048.38C1679.31 1048.38 1752.44 974.567 1794.4 922.275C1843.62 860.942 1857.94 846.831 1901.73 857.02Z",
			fill: "#0072BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2015.91 1431.75H1645.18C1625.3 1431.75 1609.18 1417.31 1609.18 1399.51C1609.18 1381.7 1625.3 1367.26 1645.18 1367.26H2015.91C2027.41 1367.26 2037.25 1360.25 2039.86 1350.22L2156.27 901.958C2160.78 884.609 2180.17 873.833 2199.49 877.857C2218.85 881.893 2230.9 899.226 2226.39 916.571L2109.97 1364.84C2099.75 1404.24 2061.06 1431.75 2015.91 1431.75Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1136.88 1119.09H1002.81L1023.67 998.996H1157.74L1136.88 1119.09Z",
			fill: "#6C9BAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1776.87 1397.8L1797.9 1248.26C1803.04 1211.65 1837.8 1184.18 1879 1184.18H2096.59",
			stroke: "#26323A",
			strokeWidth: 8.436,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M401.94 1808.84L575.011 1159.01L542.38 1150.84L367.135 1808.84H401.94Z",
			fill: "#10275B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1531.14 1808.84L1355.9 1150.84L1323.26 1159.01L1496.33 1808.84H1531.14Z",
			fill: "#10275B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1337.56 981.411C1340.41 988.665 1339.16 996.712 1334.2 1002.99C1329.24 1009.27 1321.19 1013.01 1312.6 1013.01H854.258C843.038 1013.01 833.036 1006.67 829.302 997.19L719.728 719.037C716.869 711.783 718.12 703.737 723.081 697.456C728.041 691.175 736.096 687.442 744.684 687.442H1203.02C1214.25 687.442 1224.25 693.781 1227.98 703.26L1337.56 981.411Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1188.89 774.165L1179.64 750.682H806.386L815.637 774.165H1188.89Z",
			fill: "#10275B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1205.01 815.07L1192.77 784.012H819.517L831.751 815.07H1205.01Z",
			fill: "#FFD500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1213.36 836.281L1208.89 824.918H835.632L840.107 836.281H1213.36Z",
			fill: "#A2C61A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M843.987 846.129L884.962 950.146H1035.85L994.873 846.129H843.987Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1006.12 846.129L1047.1 950.146H1254.07L1213.09 846.129H1006.12Z",
			fill: "#3AAA35"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1203.03 687.442H744.684C726.425 687.442 713.652 703.615 719.728 719.038L829.302 997.189C833.037 1006.67 843.037 1013.01 854.258 1013.01H1312.6C1321.19 1013.01 1329.24 1009.27 1334.2 1002.99C1339.16 996.712 1340.41 988.665 1337.56 981.411L1227.98 703.259C1224.25 693.781 1214.25 687.442 1203.03 687.442ZM1198.42 716.985L1303.39 983.463H858.868L753.892 716.985H1198.42Z",
			fill: "#87AFB9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1205.01 1118.76L1002.81 1119.1L1007.7 1090.95H1173.97C1191.11 1090.95 1205.01 1103.4 1205.01 1118.76Z",
			fill: "#87AFB9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2251.85 855.014C2241.39 841.212 2235.43 824.897 2236.54 808.249C2237.73 790.482 2235.36 765.582 2221.11 737.066C2203.68 702.187 2170.79 683.336 2140.13 673.15C2104.63 661.358 2077.72 635.544 2062.6 604.448C2056.69 592.285 2046.94 580.719 2031.07 572.771C1959.71 537.013 1920.62 559.748 1905.16 573.941C1891.52 586.449 1876.76 597.86 1861.66 608.943L1831.13 631.371L1863.76 654.8C1885.84 648.78 1908.63 661.688 1912.33 682.102C1947.24 874.974 2012.19 996.751 2208.42 954.813C2260.38 943.709 2278.59 890.338 2251.85 855.014Z",
			fill: "#26323A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1730.25 743.746C1738.37 736.402 1751.61 736.351 1759.8 743.631",
			stroke: "#FFD500",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1736.59 743.138C1736.65 755.605 1725.42 765.755 1711.5 765.81C1697.59 765.863 1686.26 755.801 1686.2 743.334C1686.14 730.866 1697.37 720.716 1711.29 720.661C1725.2 720.607 1736.53 730.67 1736.59 743.138Z",
			stroke: "#FFD500",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1803.85 742.877C1803.91 755.344 1792.68 765.494 1778.76 765.549C1764.84 765.602 1753.51 755.54 1753.45 743.072C1753.39 730.605 1764.63 720.455 1778.54 720.4C1792.46 720.347 1803.79 730.409 1803.85 742.877Z",
			stroke: "#FFD500",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1803.85 742.876L1835.43 716.087C1838.33 713.63 1842.16 712.255 1846.14 712.239C1852.47 712.214 1858.2 715.602 1860.66 720.827L1862.59 724.932",
			stroke: "#FFD500",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1643.1 801.699L1652.72 785.096C1653.61 776.043 1654.74 758.742 1668.11 744.178L1682.1 730.259C1684.83 728.018 1691.06 722.024 1694.41 723.558C1697.75 725.092 1695.72 737.676 1695.01 740.846L1693.65 746.899L1691.11 767.72C1689.01 775.766 1675.71 790.747 1675.71 790.747L1665.44 808.359L1643.1 801.699Z",
			fill: "#FFB573"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1584.21 1207.23H376.234C373.165 1207.23 370.678 1205 370.678 1202.25V1123.74C370.678 1120.99 373.165 1118.76 376.234 1118.76H1584.21C1587.28 1118.76 1589.77 1120.99 1589.77 1123.74V1202.25C1589.77 1205 1587.28 1207.23 1584.21 1207.23Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1035.85 1105.02H390.133C364.246 1105.02 343.258 1123.82 343.258 1147.01V1476.28C343.258 1499.47 364.246 1518.27 390.133 1518.27H432.845",
			stroke: "#87AFB9",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M471.073 1703.56H585.669",
			stroke: "#10275B",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M471.073 1725.36H585.669",
			stroke: "#10275B",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M471.073 1747.16H585.669",
			stroke: "#10275B",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M471.073 1768.96H585.669",
			stroke: "#10275B",
			strokeWidth: 8.436,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1080.27 1466.35H980.225V1448.64H1080.27V1466.35Z",
			fill: "#10275B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1080.27 1713.26C1080.27 1718.61 1075.43 1722.95 1069.45 1722.95C1063.48 1722.95 1058.63 1718.61 1058.63 1713.26C1058.63 1707.9 1063.48 1703.56 1069.45 1703.56C1075.43 1703.56 1080.27 1707.9 1080.27 1713.26Z",
			fill: "#FFD500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1076.32 1741.29C1076.32 1744.68 1073.25 1747.44 1069.45 1747.44C1065.66 1747.44 1062.58 1744.68 1062.58 1741.29C1062.58 1737.89 1065.66 1735.13 1069.45 1735.13C1073.25 1735.13 1076.32 1737.89 1076.32 1741.29Z",
			fill: "#FFD500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1080.27 1659.9H980.225V1500.2H1080.27V1659.9Z",
			fill: "#E6E6E6"
		})
	]
});
const ForwardRef = forwardRef(SvgIndoor);
export default ForwardRef;
